// frontend/src/services/chatService.ts
import { co } from '@fullcalendar/core/internal-common';
import axios from 'axios';
import { Conversation, Message } from 'data/chat'; 

// Esta es la dirección de TU servidor de Node, no la de Meta
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:2000';

export const getChatConversations = async (): Promise<Conversation[]> => {
  // Llama al endpoint que creamos en el controlador de Express
  const response = await axios.get(`${apiUrl}/whatsapps/getConversations`);
  return response.data;
};

export const postSendMessage = async (to: string, message: string, miem: string | number) => {
  const response = await axios.post(`${apiUrl}/whatsapps/store`, {
    to: to,
    message: message,
    miem: miem // <-- Lo enviamos al backend
  });
  console.log('Response from server:', response.data);
  return response.data;
};

export const putMarkAsRead = async (conversacionId: string | number) => {
  await axios.put(`${apiUrl}/whatsapps/mark-as-read/${conversacionId}`);
};

export const formatCelular = (celular: string) => {
  if (!celular) return '';
  
  // Limpiamos cualquier caracter que no sea número por seguridad
  const cleaned = celular.replace(/\D/g, '');

  // Si tiene exactamente 13 dígitos, aplicamos el formato
  if (cleaned.length === 13) {
    return `${cleaned.slice(0, 2)} ${cleaned.slice(2, 3)} ${cleaned.slice(3, 5)} ${cleaned.slice(5, 9)} ${cleaned.slice(9, 13)}`;
  }

  // Si no tiene 13 dígitos, devolvemos el valor original para no cortarlo mal
  return celular;
};

import dayjs from 'dayjs';

// Función para calcular si la ventana de 24hs está abierta
// Función blindada para calcular 24hs
export const is24hWindowOpen = (messages: Message[]) => {
  if (!messages || messages.length === 0) return false;

  const lastInbound = [...messages].reverse().find(m => m.type === 'received');

  // Si no hay mensajes recibidos en toda la historia, está cerrada
  if (!lastInbound) return false;

  // Si el mensaje acaba de entrar por socket y no tiene timestamp, asumimos que es de ahora
  const messageTime = lastInbound.createdAt ? dayjs(lastInbound.createdAt) : dayjs();

  // Calculamos la diferencia
  const hoursDifference = dayjs().diff(messageTime, 'hour');
  
  return hoursDifference < 24;
};